/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { CenterStockItem } from './CenterStockItem';
import {
    CenterStockItemFromJSON,
    CenterStockItemFromJSONTyped,
    CenterStockItemToJSON,
    CenterStockItemToJSONTyped,
} from './CenterStockItem';

/**
 * 
 * @export
 * @interface ResponseCenterStockItem
 */
export interface ResponseCenterStockItem {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCenterStockItem
     */
    result: ResponseResult;
    /**
     * 
     * @type {CenterStockItem}
     * @memberof ResponseCenterStockItem
     */
    data: CenterStockItem;
}

/**
 * Check if a given object implements the ResponseCenterStockItem interface.
 */
export function instanceOfResponseCenterStockItem(value: object): value is ResponseCenterStockItem {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCenterStockItemFromJSON(json: any): ResponseCenterStockItem {
    return ResponseCenterStockItemFromJSONTyped(json, false);
}

export function ResponseCenterStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCenterStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CenterStockItemFromJSON(json['data']),
    };
}

export function ResponseCenterStockItemToJSON(json: any): ResponseCenterStockItem {
    return ResponseCenterStockItemToJSONTyped(json, false);
}

export function ResponseCenterStockItemToJSONTyped(value?: ResponseCenterStockItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CenterStockItemToJSON(value['data']),
    };
}

